<template>
    <div>
        <div class="z-50 absolute top-2 right-1 max-h-[50dvh] overflow-y-auto bg-transparent space-y-2 w-96">
            <SharedAlertPopup v-for="(alert, index) in alerts" :type="alert.type" :message="alert.message" @close="() => removeIndex(index)"/>
        </div>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">

const alerts = ref<Alert[]>([]);
provide(AlertFnKey, (message: string, type: AlertType, timeout?: number) => {
    alerts.value.push({ message, type });
    setTimeout(() => {
        const index = alerts.value.findIndex((a) => a.message === message);
        if (index >= 0) alerts.value.splice(index, 1);
    }, timeout || 3000);
});

function removeIndex(index: number) {
    alerts.value.splice(index, 1);
}
</script>